import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349ad750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Bid" }
const _hoisted_2 = { class: "mb-2 font-semibold" }
const _hoisted_3 = {
  key: 4,
  class: "Bid__content"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка заявки...", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "content__header" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "ml-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выше нормы себестоимости", -1))
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "bg-white flex items-center justify-between p-4 mt-3"
}
const _hoisted_15 = { class: "flex flex-col gap-2" }
const _hoisted_16 = {
  key: 0,
  class: "fas fa-check mr-2 text-green-500"
}
const _hoisted_17 = {
  key: 1,
  class: "fas fa-exclamation mr-4"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation mr-4" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Необходимо подтверждение Руководителя Операционного Управления ", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_23 = { class: "content__body" }
const _hoisted_24 = {
  key: 0,
  class: "BidContent__box"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Общая информация", -1))
const _hoisted_26 = { class: "mt-3" }
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "BidContent__row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Перевозчик", -1))
const _hoisted_30 = { class: "BidContent__row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Проект", -1))
const _hoisted_32 = { class: "BidContent__row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Догруз", -1))
const _hoisted_34 = { class: "BidContent__row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Направление", -1))
const _hoisted_36 = { class: "BidContent__row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Грузоотправитель", -1))
const _hoisted_38 = { class: "BidContent__row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Адрес загрузки", -1))
const _hoisted_40 = { class: "BidContent__row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Дата загрузки", -1))
const _hoisted_42 = { class: "BidContent__row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Контактное лицо, тел.", -1))
const _hoisted_44 = { class: "BidContent__row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Грузополучатель", -1))
const _hoisted_46 = { class: "BidContent__row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Адрес разгрузки", -1))
const _hoisted_48 = { class: "BidContent__row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Дата разгрузки", -1))
const _hoisted_50 = { class: "BidContent__row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Контактное лицо, тел.", -1))
const _hoisted_52 = { class: "BidContent__row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Номер рейса", -1))
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 1,
  class: "BidContent__box"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Трех. стор. договор", -1))
const _hoisted_57 = { class: "mt-3" }
const _hoisted_58 = { class: "w-full" }
const _hoisted_59 = { class: "BidContent__row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Номер договора", -1))
const _hoisted_61 = { class: "BidContent__row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Дата договора", -1))
const _hoisted_63 = {
  key: 2,
  class: "BidContent__box"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Комментарии по себестоимости", -1))
const _hoisted_65 = { class: "mt-3" }
const _hoisted_66 = { class: "w-full" }
const _hoisted_67 = {
  key: 0,
  class: "whitespace-nowrap"
}
const _hoisted_68 = {
  key: 1,
  class: "whitespace-nowrap"
}
const _hoisted_69 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_70 = {
  key: 3,
  class: "BidContent__box"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Характеристики груза", -1))
const _hoisted_72 = { class: "mt-3" }
const _hoisted_73 = { class: "w-full" }
const _hoisted_74 = { class: "BidContent__row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Характер груза, вес, объём ", -1))
const _hoisted_76 = { class: "BidContent__row" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Тип кузова", -1))
const _hoisted_78 = { class: "BidContent__row" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Температурный режим", -1))
const _hoisted_80 = {
  key: 4,
  class: "BidContent__box"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Данные водителя и ТС", -1))
const _hoisted_82 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_83 = { class: "w-full" }
const _hoisted_84 = { class: "BidContent__row" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "ФИО собственника ТС", -1))
const _hoisted_86 = { class: "BidContent__row" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "ФИО водителя", -1))
const _hoisted_88 = { class: "BidContent__row" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Телефон", -1))
const _hoisted_90 = { class: "BidContent__row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Номер технического паспорта ", -1))
const _hoisted_92 = { class: "BidContent__row" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Гос. номер авто", -1))
const _hoisted_94 = { class: "BidContent__row" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Тип Т/С", -1))
const _hoisted_96 = { class: "BidContent__row" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Марка авто", -1))
const _hoisted_98 = { class: "BidContent__row" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Гос. номер прицепа", -1))
const _hoisted_100 = { class: "BidContent__row" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Номер удостоверения личности ", -1))
const _hoisted_102 = { class: "BidContent__row" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Дата выдачи удостоверения личности ", -1))
const _hoisted_104 = { class: "BidContent__row" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Номер водительского удостоверения ", -1))
const _hoisted_106 = { class: "BidContent__row" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Дата выдачи водительского удостоверения ", -1))
const _hoisted_108 = { class: "BidContent__row" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Фото тех. паспорта", -1))
const _hoisted_110 = ["src"]
const _hoisted_111 = {
  key: 5,
  class: "BidContent__box"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Оплата", -1))
const _hoisted_113 = { class: "w-full mt-3" }
const _hoisted_114 = { class: "BidContent__row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Страхование", -1))
const _hoisted_116 = { class: "BidContent__row" }
const _hoisted_117 = { class: "BidContent__placeholder" }
const _hoisted_118 = { class: "flex items-center" }
const _hoisted_119 = { class: "BidContent__row" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Норма себестоимости", -1))
const _hoisted_121 = { class: "BidContent__row" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Срок и форма оплаты", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_update_signers_modal = _resolveComponent("update-signers-modal")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!
  const _component_bids_change_status_form = _resolveComponent("bids-change-status-form")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_bid_signatories = _resolveComponent("bid-signatories")!
  const _component_bids_tabs = _resolveComponent("bids-tabs")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.update_signers_state.is_opened)
      ? (_openBlock(), _createBlock(_component_update_signers_modal, {
          key: 0,
          loading: _ctx.bid_state.is_actions_loading,
          signers: _ctx.update_signers_state.signers,
          onConfirm: _ctx.updateSigners,
          onCancel: _ctx.cancelUpdateSigners
        }, null, 8, ["loading", "signers", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state_cost.is_open)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          title: "Редактирование стоимости перевозки",
          class: "medium",
          loading: _ctx.state_cost.is_loading,
          onConfirm: _ctx.editCost,
          onCancel: _ctx.toggleCost
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, " Сумму необходимо вносить " + _toDisplayString(_ctx.state.bid?.isNds ? 'с' : 'без') + " НДС ", 1),
            _createVNode(_component_the_input, {
              placeholder: "Стоимость перевозки",
              disabled: _ctx.state_cost.is_loading,
              value: _ctx.state_cost.cost,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state_cost.cost) = $event)),
              "is-invalid": _ctx.cost_form$.cost.$error,
              "validation-errors": _ctx.cost_form$.cost.$errors
            }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
            _createVNode(_component_checkbox, {
              value: _ctx.state_cost.isNds,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state_cost.isNds) = $event)),
              disabled: _ctx.state_cost.is_loading,
              label: "С НДС",
              class: "mt-2",
              "return-integer": ""
            }, null, 8, ["value", "disabled"])
          ]),
          _: 1
        }, 8, ["loading", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_status_changing)
      ? (_openBlock(), _createBlock(_component_bids_change_status_form, {
          key: 2,
          "bid-id": Number(_ctx.$route.params.id),
          "is-accept": _ctx.state.is_accept_status,
          "is-decline": _ctx.state.is_decline_status,
          onCancel: _ctx.onCancelStatusChange,
          onStatusChanged: _ctx.onStatusChanged
        }, null, 8, ["bid-id", "is-accept", "is-decline", "onCancel", "onStatusChanged"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 3,
          loading: _ctx.state.is_loading,
          text: "При получении заявки произошла ошибка",
          onRefresh: _ctx.loadBid
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_5
              ]))
            : (_ctx.state.bid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_page_title, {
                          title: `Заявка №${_ctx.state.bid.id}`
                        }, null, 8, ["title"]),
                        (_ctx.state.bid && _ctx.state.bid.status)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 0,
                              class: _normalizeClass(["ml-3 small", {
                                    yellow: _ctx.state.bid.status.id === 13,
                                    green: _ctx.state.bid.status.id === 14,
                                    red: _ctx.state.bid.status.id === 17,
                                }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.bid.status.name), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.state.bid.route && _ctx.state.bid.createdAt)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 1,
                              class: "ml-3 small blue flex items-center justify-between"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.state.bid.route), 1),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.state.bid.createdAt), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.state.bid.route && _ctx.state.bid.isAboveCostStandard)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 2,
                              class: "red ml-3 small flex items-center justify-between"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.state.contractId)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/contracts/${_ctx.state.contractId}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_the_button, { class: "primary text small" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Перейти к договору с перевозчиком ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, { to: "/bids" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_the_button, { class: "second text small" }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _createTextVNode(" Назад ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  (_ctx.isConfirmShowed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, " Себестоимость перевозки по нормам: " + _toDisplayString(_ctx.state.bid.costStandardValue || 0) + " ₸ (без НДС) ", 1),
                          _createElementVNode("div", null, [
                            _createTextVNode(" Себестоимость перевозки указанная в заявке: " + _toDisplayString(_ctx.state.bid.costDependingOnVat || 0) + " ₸ ", 1),
                            (_ctx.state.bid.isNds)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("(с НДС)")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("(без НДС)")
                                ], 64))
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.isConfirmedByHeadOfTransport)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                              : (_openBlock(), _createElementBlock("i", _hoisted_17)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.headOfTransportConfirmationText), 1)
                          ]),
                          (_ctx.state.bid.confirmedDetails.isNeedSecondConfirmation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.isCanConfirmOrCancel)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_the_button, {
                                class: "small primary",
                                onClick: _ctx.onAccepted
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Подтверждено ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_the_button, {
                                class: "small red",
                                onClick: _ctx.onDeclined
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Отказано ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.bid.status.id === 13)
                    ? (_openBlock(), _createBlock(_component_bid_signatories, {
                        key: 1,
                        class: "mt-3",
                        "actions-loading": _ctx.bid_state.is_actions_loading,
                        loading: _ctx.bid_state.is_loading,
                        failed: _ctx.bid_state.is_failed,
                        bid: _ctx.bid_state.bid,
                        onUpdate: _ctx.onBidUpdateSigners,
                        onCheck: _ctx.onCheckBid,
                        onDelete: _ctx.onDeleteBid
                      }, null, 8, ["actions-loading", "loading", "failed", "bid", "onUpdate", "onCheck", "onDelete"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_bids_tabs, {
                    class: "mt-3",
                    value: _ctx.state.currentTab,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.currentTab) = $event))
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.isGeneral)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.carrier ? _ctx.state.bid.carrier.shortName : '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("p", null, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.state.bid.isProject))
                                  }, null, 2)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("p", null, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.state.bid.isAdditionalLoad))
                                  }, null, 2)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.route), 1)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.senderFullName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.loadAddress || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.dateOfLoad) || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.senderPhone || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.receiverFullName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.unloadAddress || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _hoisted_49,
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.dateOfUnload) || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _hoisted_51,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.receiverPhone || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                (
                                            _ctx.state.bid.trip &&
                                            _ctx.state.bid.trip.id &&
                                            _ctx.state.bid.trip.number
                                        )
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: `/tms/trips/${_ctx.state.bid.trip.id}`,
                                      class: "font-semibold text-blue-500"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.state.bid.trip.number), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_54, "-"))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isGeneral)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _hoisted_60,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.tripartiteNumber || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.tripartiteDate) || '-'), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isGeneral && _ctx.state.bid.details && _ctx.state.bid.details.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_component_table_scroll_wrapper, {
                                loading: _ctx.state.is_loading
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_the_table, {
                                    loading: _ctx.state.is_loading,
                                    columns: _ctx.DetailsColumns,
                                    rows: _ctx.state.bid.details
                                  }, {
                                    td: _withCtx(({ row, column }) => [
                                      (column.key === 'costOfTransportation')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(row.costOfTransportation) + " тг. ", 1))
                                        : (column.key === 'status')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                              _createVNode(_component_cheap, {
                                                class: _normalizeClass(["small", {
                                                            green: [
                                                                'Подтверждено',
                                                                'В пределах нормы',
                                                            ].includes(row.status),
                                                            red: [
                                                                'Отказано',
                                                                'Выше нормы себестоимости',
                                                            ].includes(row.status),
                                                        }])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(row.status || 'Нет статуса'), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(row[column.key] || '-'), 1))
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "columns", "rows"])
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCargo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _hoisted_75,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.natureOfCargo || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _hoisted_77,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.bodyType || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.temperatureRegime || '-'), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCourier)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _hoisted_81,
                          (_ctx.state.bid.driver)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("div", _hoisted_84, [
                                    _hoisted_85,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.vehicle_owner_full_name || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_86, [
                                    _hoisted_87,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.fullName || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_88, [
                                    _hoisted_89,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.phone || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_90, [
                                    _hoisted_91,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.car_technical_passport || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_92, [
                                    _hoisted_93,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.carNumber || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_94, [
                                    _hoisted_95,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.carType || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_96, [
                                    _hoisted_97,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.carBrand || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_98, [
                                    _hoisted_99,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.trailerLicenseNumber || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_100, [
                                    _hoisted_101,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.identifyCard || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_102, [
                                    _hoisted_103,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.driver.identifyCardDate) || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_104, [
                                    _hoisted_105,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.license || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_106, [
                                    _hoisted_107,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.driver.licenseDate) || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_108, [
                                    _hoisted_109,
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.bid
                                                .carTechnicalPassportFiles, (file, idx) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          src: file.url,
                                          key: `file-${idx}`,
                                          alt: "carTechnicalPassportFiles",
                                          class: "mb-2"
                                        }, null, 8, _hoisted_110))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isPayment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                          _hoisted_112,
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                              _hoisted_115,
                              _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.insurance || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _createElementVNode("p", _hoisted_117, " Стоимость перевозки " + _toDisplayString(_ctx.getVatText), 1),
                              _createElementVNode("div", _hoisted_118, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.costOfTransportation || '-') + " ₸", 1),
                                (
                                            _ctx.state.bid &&
                                            _ctx.state.bid.status &&
                                            _ctx.state.bid.status.id === 17
                                        )
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: "EditCost fas fa-pen",
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCost && _ctx.toggleCost(...args)))
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_119, [
                              _hoisted_120,
                              _createElementVNode("p", null, [
                                (_ctx.state.bid.costStandard)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.state.bid.costStandard.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.state.bid.costStandard.value), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("-")
                                          ], 64)),
                                      _createTextVNode(" ₸ ("),
                                      (_ctx.state.bid.costStandard.valuePerWeight)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createTextVNode(_toDisplayString(_ctx.state.bid.costStandard.valuePerWeight), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createTextVNode("-")
                                          ], 64)),
                                      _createTextVNode(" ₸/кг) ")
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_121, [
                              _hoisted_122,
                              _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.termAndFormOfPayment || '-'), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
  ]))
}